// format percent string

export function formatPercentString(value: string) {
  const result = parseFloat(value);
  if (isNaN(result)) {
    return "-";
  }
  return `${result.toFixed(2)}%`;
}
